import TopBar from "../../components/topBar/topBar";
import { useEffect, useState } from 'react';
import { validateMonoForm } from "../../validators/monoForm.validator";
import { getCitation } from "../../helpers/citation.helper";
import { getFormAuthors } from "../../helpers/authors.helper";
import { getKeywords } from "../../helpers/keywords.helper";
import { apiClient } from "../../api/apiClient";
import { useNavigate } from "react-router-dom";

function EditFormMono({ setPageState, setSuccess, book }) {
    const [formValues, setFormValues] = useState({
        title: '',
        city: '',
        year: '',
        publisher: '',
        full_pages: 0,
        isbn: '',
        citation_type: 1,
    })

    const navigate = useNavigate();

    const [formErrors, setFormErrors] = useState({});
    const [authors, setAuthors] = useState('');
    const [keywords, setKeywords] = useState('');

    useEffect(() => {
        console.log('Running');
        if (book.title || book.archive) {
            setFormValues(book);
            console.log(book);
            if (book.authors.length > 1) {
                setAuthors(book.authors.join(' - '));
            } else {
                setAuthors(book.authors[0]);
            }
            if (book.keywords.length > 1) {
                setKeywords(book.keywords.join(', '));
            } else {
                setKeywords(book.keywords[0]);
            }
        }
        console.log(formValues);
    }, [book])

    async function handleSubmit() {

        // Good stuff
        const finalBody = {
            ...formValues, authors: getFormAuthors(authors), keywords: getKeywords(keywords)
        }

        const req = await apiClient.put(`/book/${formValues._id}`, finalBody);
        if (req.status === 200) {
            console.log('Book added');
            navigate('/view-books');
            setFormValues({
                title: '',
                city: '',
                year: '',
                publisher: '',
                full_pages: 0,
                isbn: '',
                citation_type: 1,
            });
            setAuthors('');
            setKeywords('');
            setPageState?.(0);
            setSuccess?.(true);

        } else {
            console.log(req);
        }

        console.log(finalBody);
    }

    return (
        <div className="min-h-screen">
            <TopBar logo={true} />
            <div className="mx-auto max-w-2xl px-4 sm:px-6 py-10">

                <button
                    type="button"
                    onClick={() => navigate('/view-books')}
                    className="group mb-8 -ml-1 inline-flex items-center gap-2 text-sm font-light text-mainDark/40 transition-colors duration-200 hover:text-mainDark"
                >
                    <svg className="h-4 w-4 transition-transform duration-200 group-hover:-translate-x-1" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="M19 12H5M12 5l-7 7 7 7" />
                    </svg>
                    Go Back
                </button>

                <h1 className="mb-8 text-2xl font-light text-mainDark">Upraviť {book.title}</h1>

                <div className="flex flex-col gap-5">
                    {formValues.citation_type !== 7 && (
                        <div className="w-full">
                            <label htmlFor="title" className="block text-base font-medium ml-3 text-mainBlue pb-2">Title</label>
                            <input type="text" defaultValue={formValues.title} className='formInput' onChange={e => setFormValues(values => ({ ...values, title: e.target.value }))} />
                            <p className='text-sm text-red-500 ml-3 mt-1'>{formErrors.title}</p>
                        </div>
                    )}
                    {formValues.citation_type !== 7 && (
                        <div className="w-full">
                            <label htmlFor="author" className="block text-base font-medium ml-3 text-mainBlue pb-0">Authors</label>
                            <p className='ml-3 text-sm text-mainDark italic font-thin'>Meno Priezvisko - Meno Priezvisko - Meno Priezvisko</p>
                            <input type="text" defaultValue={authors} className='formInput' onChange={e => setAuthors(e.target.value)} />
                            <p className='text-sm text-red-500 ml-3 mt-1'>{formErrors.authors}</p>
                        </div>
                    )}
                    {formValues.citation_type !== 7 && formValues.citation_type !== 4 && (
                        <div className="w-full">
                            <label htmlFor="city" className="block text-base font-medium ml-3 text-mainBlue pb-2">City</label>
                            <input type="text" defaultValue={formValues.city} className='formInput' onChange={e => setFormValues(values => ({ ...values, city: e.target.value }))} />
                            <p className='text-sm text-red-500 ml-3 mt-1'>{formErrors.city}</p>
                        </div>
                    )}
                    {formValues.citation_type !== 7 && (
                        <div className="w-full">
                            <label htmlFor="year" className="block text-base font-medium ml-3 text-mainBlue pb-2">Year</label>
                            <input type="text" defaultValue={formValues.year} className='formInput' onChange={e => setFormValues(values => ({ ...values, year: e.target.value }))} />
                            <p className='text-sm text-red-500 ml-3 mt-1'>{formErrors.year}</p>
                        </div>
                    )}
                    {formValues.citation_type !== 7 && (
                        <div className="w-full">
                            <label htmlFor="publisher" className="block text-base font-medium ml-3 text-mainBlue pb-2">Publisher</label>
                            <input type="text" defaultValue={formValues.publisher} className='formInput' onChange={e => setFormValues(values => ({ ...values, publisher: e.target.value }))} />
                            <p className='text-sm text-red-500 ml-3 mt-1'>{formErrors.publisher}</p>
                        </div>
                    )}
                    {formValues.citation_type == 6 && (
                        <div className="w-full">
                            <label htmlFor="publisher_online" className="block text-base font-medium ml-3 text-mainBlue pb-2">Publisher Online</label>
                            <input type="text" defaultValue={formValues.publisher_online} className='formInput' onChange={e => setFormValues(values => ({ ...values, publisher_online: e.target.value }))} />
                            <p className='text-sm text-red-500 ml-3 mt-1'>{formErrors.publisher_online}</p>
                        </div>
                    )}
                    {formValues.citation_type == 1 || formValues.citation_type == 2 || formValues.citation_type == 3 && (
                        <div className="w-full">
                            <label htmlFor="full_pages" className="block text-base font-medium ml-3 text-mainBlue pb-2">Pages</label>
                            <input type="number" defaultValue={formValues.full_pages} className='formInput' onChange={e => setFormValues(values => ({ ...values, full_pages: e.target.value }))} />
                            <p className='text-sm text-red-500 ml-3 mt-1'>{formErrors.full_pages}</p>
                        </div>
                    )}
                    {formValues.citation_type !== 7 && formValues.citation_type !== 6 && (
                        <div className="w-full">
                            <label htmlFor="isbn" className="block text-base font-medium ml-3 text-mainBlue pb-2">ISBN/ISSN</label>
                            <input type="text" defaultValue={formValues.isbn} className='formInput' onChange={e => setFormValues(values => ({ ...values, isbn: e.target.value }))} />
                            <p className='text-sm text-red-500 ml-3 mt-1'>{formErrors.isbn}</p>
                        </div>
                    )}
                    {formValues.citation_type == 4 || formValues.citation_type == 5 || formValues.citation_type == 6 && (
                        <div className="w-full">
                            <label htmlFor="pageFrom" className="block text-base font-medium ml-3 text-mainBlue pb-2">Page From</label>
                            <input defaultValue={formValues.pageFrom} type="number" className='formInput' onChange={e => setFormValues(values => ({ ...values, pageFrom: e.target.value }))} />
                            <p className='text-sm text-red-500 ml-3 mt-1'>{formErrors.pageFrom}</p>
                        </div>
                    )}
                    {formValues.citation_type == 4 || formValues.citation_type == 5 || formValues.citation_type == 6 && (
                        <div className="w-full">
                            <label htmlFor="pageTo" className="block text-base font-medium ml-3 text-mainBlue pb-2">Page To</label>
                            <input type="number" defaultValue={formValues.pageTo} className='formInput' onChange={e => setFormValues(values => ({ ...values, pageTo: e.target.value }))} />
                            <p className='text-sm text-red-500 ml-3 mt-1'>{formErrors.pageTo}</p>
                        </div>
                    )}
                    {formValues.citation_type == 4 && (
                        <div className="w-full">
                            <label htmlFor="parent_article" className="block text-base font-medium ml-3 text-mainBlue pb-2">Parent article</label>
                            <input type="text" defaultValue={formValues.parent_article} className='formInput' onChange={e => setFormValues(values => ({ ...values, parent_article: e.target.value }))} />
                            <p className='text-sm text-red-500 ml-3 mt-1'>{formErrors.parent_article}</p>
                        </div>
                    )}
                    {formValues.citation_type == 4 && (
                        <div className="w-full">
                            <label htmlFor="parent_author" className="block text-base font-medium ml-3 text-mainBlue pb-2">Parent author</label>
                            <input type="text" className='formInput' defaultValue={formValues.parent_author} onChange={e => setFormValues(values => ({ ...values, parent_author: e.target.value }))} />
                            <p className='text-sm text-red-500 ml-3 mt-1'>{formErrors.parent_author}</p>
                        </div>
                    )}
                    {formValues.citation_type == 5 && (
                        <div className="w-full">
                            <label htmlFor="vol" className="block text-base font-medium ml-3 text-mainBlue pb-2">Vol (ročník)</label>
                            <input type="number" className='formInput' defaultValue={formValues.vol} onChange={e => setFormValues(values => ({ ...values, vol: e.target.value }))} />
                            <p className='text-sm text-red-500 ml-3 mt-1'>{formErrors.vol}</p>
                        </div>
                    )}
                    {formValues.citation_type == 5 && (
                        <div className="w-full">
                            <label htmlFor="num" className="block text-base font-medium ml-3 text-mainBlue pb-2">Num (číslo)</label>
                            <input type="number" className='formInput' defaultValue={formValues.num} onChange={e => setFormValues(values => ({ ...values, num: e.target.value }))} />
                            <p className='text-sm text-red-500 ml-3 mt-1'>{formErrors.num}</p>
                        </div>
                    )}
                    {formValues.citation_type == 6 && (
                        <div className="w-full">
                            <label htmlFor="url" className="block text-base font-medium ml-3 text-mainBlue pb-2">URL</label>
                            <input type="text" className='formInput' defaultValue={formValues.url} onChange={e => setFormValues(values => ({ ...values, url: e.target.value }))} />
                            <p className='text-sm text-red-500 ml-3 mt-1'>{formErrors.url}</p>
                        </div>
                    )}
                    {formValues.citation_type == 7 && (
                        <>
                            <div className="w-full">
                                <label htmlFor="archive" className="block text-base font-medium ml-3 text-mainBlue pb-2">Archive</label>
                                <input type="text" defaultValue={formValues.archive} className='formInput' onChange={e => setFormValues(values => ({ ...values, archive: e.target.value }))} />
                                <p className='text-sm text-red-500 ml-3 mt-1'>{formErrors.archive}</p>
                            </div>
                            <div className="w-full">
                                <label htmlFor="trust" className="block text-base font-medium ml-3 text-mainBlue pb-2">Trust</label>
                                <input type="text" className='formInput' defaultValue={formValues.trust} onChange={e => setFormValues(values => ({ ...values, trust: e.target.value }))} />
                                <p className='text-sm text-red-500 ml-3 mt-1'>{formErrors.trust}</p>
                            </div>
                            <div className="w-full">
                                <label htmlFor="crate" className="block text-base font-medium ml-3 text-mainBlue pb-2">Crate</label>
                                <input type="number" className='formInput' defaultValue={formValues.crate} onChange={e => setFormValues(values => ({ ...values, crate: e.target.value }))} />
                                <p className='text-sm text-red-500 ml-3 mt-1'>{formErrors.crate}</p>
                            </div>
                            <div className="w-full">
                                <label htmlFor="doc_number" className="block text-base font-medium ml-3 text-mainBlue pb-2">Document Number</label>
                                <input type="text" className='formInput' defaultValue={formValues.doc_number} onChange={e => setFormValues(values => ({ ...values, doc_number: e.target.value }))} />
                                <p className='text-sm text-red-500 ml-3 mt-1'>{formErrors.doc_number}</p>
                            </div>
                        </>
                    )}
                    <div className="w-full">
                        <label htmlFor="keywords" className="block text-base font-medium ml-3 text-mainBlue pb-2">Keywords</label>
                        <p className='ml-3 text-sm text-mainDark italic font-thin'>Keyword, Keyword, Keyword, ...</p>
                        <input type="text" defaultValue={keywords} className='formInput' onChange={e => setKeywords(e.target.value)} />
                    </div>

                    <div className="rounded-2xl border border-mainDark/30 bg-mainWhite p-5 shadow-result">
                        <p className="text-[10px] uppercase tracking-widest font-medium text-mainBlue mb-3">Citation preview</p>
                        <p className="text-sm text-mainDark/70 font-light leading-relaxed" dangerouslySetInnerHTML={{ __html: getCitation({ ...formValues, authors: getFormAuthors(authors) }) }} />
                    </div>

                    <button
                        type="button"
                        onClick={handleSubmit}
                        className="w-full rounded-3xl bg-primary py-4 text-onPrimary shadow-search transition-all duration-200 hover:brightness-110 hover:-translate-y-0.5 hover:shadow-[0_8px_30px_rgba(0,0,0,0.25)] active:translate-y-0 active:brightness-95"
                    >
                        SUBMIT
                    </button>
                </div>

            </div>
        </div>
    );
}

export default EditFormMono;
